const TIENDANUBE_TOKEN_KEY = "tint-admin-tiendanube-token"
const DEPRECATED_LEGACY_AUTH_KEYS = [
  "authMode",
  "accessToken",
  "refreshToken",
  "lastLogin",
  "lastPassword",
  "rememberMe",
] as const

export const getTiendanubeToken = (): string | null => {
  try {
    return sessionStorage.getItem(TIENDANUBE_TOKEN_KEY)
  } catch {
    return null
  }
}

export const setTiendanubeToken = (token: string): void => {
  try {
    sessionStorage.setItem(TIENDANUBE_TOKEN_KEY, token)
  } catch {
    // Ignore storage access errors (private mode, disabled storage, etc.).
  }
}

export const clearTiendanubeToken = (): void => {
  try {
    sessionStorage.removeItem(TIENDANUBE_TOKEN_KEY)
  } catch {
    // Ignore storage access errors (private mode, disabled storage, etc.).
  }
}

export const clearDeprecatedLegacyAuthKeys = (): void => {
  try {
    for (const key of DEPRECATED_LEGACY_AUTH_KEYS) localStorage.removeItem(key)
  } catch {
    // Ignore storage access errors (private mode, disabled storage, etc.).
  }
}
